import {
  Grid,
  Typography,
} from '@mui/material';
import { ServePreferences } from '../../../../../../../Models/Departments/Details/ServePreferences';
import CheckboxInput from '../../../../../../AddLocation/Components/UI/CheckboxInput';
import * as Styles from '../../../../../../../assets/styles/appStyles';
import { gridContainer, infoGridItem } from '../../../../../Styles/CustodianAddressDetailsStyles';

export default function CaseInfo({
  servePreferences,
}: {
  servePreferences: ServePreferences | undefined;
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Typography align="left" sx={Styles.labelTitle}>
            Case
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CheckboxInput
                label="Required Date Of Loss"
                checked={servePreferences?.isRequiredDateOfLoss}
                keyName={`servePreferences.isRequiredDateOfLoss`}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Claim number"
                checked={servePreferences?.isClaimNumber}
                keyName={`servePreferences.isClaimNumber`}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires Specific Dates of Service"
                checked={servePreferences?.isRequiresSpecificDatesOfService}
                keyName={`servePreferences.isRequiresSpecificDatesOfService`}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
            <Grid item xs={6}>
              <CheckboxInput
                label="Requires DOB"
                checked={servePreferences?.isRequiresDOB}
                keyName={`servePreferences.isRequiresDOB`}
                onChange={(e: any) => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
